export class BriefingHistoryModel {
    date: string;
    fromName: string;
    recipientList: string[];
    replyTo: string;
    subject: string;
    html: string;
    feedIds: number[];
    submittedDate?: string;
    sentId: number;

    constructor(apiModel?) {
        if (apiModel) {
            this.date = apiModel.date;
            this.fromName = apiModel.fromName;
            this.recipientList = apiModel.recipientList;
            this.replyTo = apiModel.replyTo;
            this.subject = apiModel.subject;
            this.feedIds = apiModel.feedIds;
            this.submittedDate = apiModel.submittedDate;
            this.html = apiModel.html;
        }
    }
}
